import TemplateMessagesStore from "./TemplateMessagesStore";
export default TemplateMessagesStore;
